import _defineProperty from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
const _excluded = ["productType", "children", "className"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { jsx as i } from "react/jsx-runtime";
import { c as r } from "../clsx-OuTLNxxd.js";
const d = "ProductTypeColor-module_ocean__r-GN3",
  s = "ProductTypeColor-module_expedition__O0tZq",
  e = {
    ocean: d,
    expedition: s
  },
  l = _ref => {
    let {
        productType: o,
        children: t,
        className: n
      } = _ref,
      c = _objectWithoutProperties(_ref, _excluded);
    return /* @__PURE__ */i("div", _objectSpread(_objectSpread({
      "data-testid": "container",
      className: r({
        [e.ocean]: o === "ocean",
        [e.expedition]: o === "expedition"
      }, n)
    }, c), {}, {
      children: t
    }));
  };
export { l as ProductTypeColor };